import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'
import { EmptyFolder } from '../EmptyFolder/EmptyFolder'
import { PathItemRowHeader } from '../PathItem/PathItemRowHeader'
import type { FolderStore } from './FolderStore'
import { FolderVirtualList } from './FolderVirtualList'
const debug = Debug('jotta:files:Folder')
export interface FolderProps {
  store: FolderStore
  loading?: boolean
  emptyContent?: ReactNode
}
export const Folder = observer<FolderProps>(function Folder({
  store,
  loading = false,
  emptyContent = (
    <EmptyFolder
      context={store.root.route.params.context}
      pathItem={store.item}
      actions={store.actions}
    />
  ),
}) {
  return (
    <>
      <PathItemRowHeader store={store} />

      <FolderVirtualList
        showEmptyFolderComponent={store.showEmptyFolderComponent}
        store={store}
        emptyContent={emptyContent}
        loading={loading}
      />
    </>
  )
})
